import { Lookup } from '../lookup.interface';

const era = { displayValue: 'ERA Only', code: 'era' };
const intake = { displayValue: 'Intake & ERA', code: 'intake' };

export const AssessmentModes: { [name: string]: Lookup } = {
  intake,
  era,
};
